/// <reference path="../ObjectDataBuilder.ts" />
/// <reference path="../Navigation.ts" />

// Änderung/Löschen/Erweitern von InputFelder erfolgt zusätzlich in:
//
// 	- makler-ui:	loc/de-DE.json: LABEL und INPUT
// 	- makler-php: Premise/Building/Unit-Data.mapper.class.php:	- getEmptyDataStructure
// 																															- entsprechende private function map...()

namespace SPA
{
	export namespace Realtor
	{

		export class PremiseBuilder
			extends ObjectDataBuilder<Wollmilch.Data.Premise>
		{
			private m_Navigation:					Navigation;
			private	m_BoxGeneral:					ui.Box.Box;
			private	m_BoxInfrastructure:	ui.Box.Box;
			private	m_BoxMicroMacro:			ui.Box.Box;
			private	m_BoxGarages:					ui.Box.Box;
			private m_Form:								ui.Form.Form;

			public constructor( data: Wollmilch.Data.Premise, navigation: Navigation )
			{
				super( data );

				this.m_Navigation					= navigation;

				this.m_BoxGeneral					= new ui.Box.Box();
				this.m_BoxInfrastructure	= new ui.Box.Box();
				this.m_BoxMicroMacro			= new ui.Box.Box();
				this.m_BoxGarages					= new ui.Box.Box();

				this.m_Form				= new ui.Form.Form(
					{
						action: 'premise/update/' + this.m_Data.ID,
						method: 'PATCH',
						static: false,
						notSwitchable: true,
						editButtonContext: 'primary',
						submit: ( method: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
						{
							new Wollmilch.AJAX(
								{
									method,
									url: action,
									data: parameter,
									on:
									{
										success: ( text: string ): void =>
										{
											const obj = Wollmilch.jsonize( text );

											if ( obj && obj.success === true )
											{
												app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.PREMISE.success_edit' ) ], context: 'success' });
											}
											else
											{
												app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.PREMISE.error_edit' ) ], context: 'danger' });
											}
										}
									}
								},
								Wollmilch.AJAXCallbase_e.REALTOR
							).send();
						}
					}
				);
				this.m_Form.Initialize();
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement>, navigation: Navigation ): PremiseBuilder
			{
				this.m_Form.rebuild( root.empty() );

				this.showCompletePremise();

				return this;
			}

			public afterBuild(): void
			{
				if ( this.m_Data )
				{
					this.m_Navigation.addRegister( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.PREMISE.LABEL.specials' ), new SPA.Realtor.SpecialsBuilder( this.m_Data ) );

					if ( this.m_Data.Building )
					{
						this.m_Data.Building.forEach( ( building: Wollmilch.Data.Building ) =>
						{
							this.m_Navigation.addRegister( building.Name ? building.Name : app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.PREMISE.LABEL.new_building' ), new SPA.Realtor.BuildingBuilder( building, this.m_Navigation ) );
						});
					}
				}
			}

			private showCompletePremise(): void
			{
				this.showPremiseGeneral();
				this.showPremiseInfrastructure();
				this.showPremiseMicroMacro();
				this.showPremiseGarages();

				// Button
				new ui.Box.Box()
					.append( $( this.m_Form.Buttons.submit.getElement() ).text( app.getMessage( 'Aux.SAVE_BTN' ) ) )
					// .append( $( this.m_Form.Buttons.reset.getElement() ).text( app.getMessage( 'Aux.RESET_BTN' ) ) )
					.append( $( this.m_Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ) )
				.appendTo( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// addBuilding
				this.m_Form.append(
					$( new Button(
						{ title: 'neues Gebäude',
							on:
							{
								click: () =>
								{
									const t = new Wollmilch.AJAX(
									{
										method: 'POST',
										url: 'premise/addBuilding/' + this.m_Data.ID,
										on:
										{
											success: ( text: string ): void =>
											{
												const obj = Wollmilch.jsonize( text );
												if ( obj && obj.success === true )
												{
													this.m_Navigation.addRegister( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.PREMISE.LABEL.new_building' ), new SPA.Realtor.BuildingBuilder( obj.data, this.m_Navigation ) );
													app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.PREMISE.success_new' ) ], context: 'success' });
												}
												else
												{
													app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.PREMISE.error_new' ) ], context: 'danger' }); }
											}
										}
									},
									Wollmilch.AJAXCallbase_e.REALTOR
									).send();
								}
							}
						}
					).getElement() )
				);

			}

			private showPremiseGeneral(): void
			{
				this.m_BoxGeneral.clearTitle();
				this.m_BoxGeneral.addTitle( app.getSpanMessage( 'Realtor.OBJECT.TITLE.PREMISE.General' ) );
				this.m_BoxGeneral.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Zuschnitt Radio
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.m_Form.Input( input );
				
					input.Base().addClass( baseclass.join( ' ' ) );
				};
				
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'General.Layout.Rating',
							required: false,
							inline: 2,
							value: this.m_Data.Data.General.Layout.Rating || undefined,
							radioButtons:
							[
								{
									value: 'good',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.Layout.Rating.good' ),
									descriptor: {}
								},
								{
									value: 'bad',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.Layout.Rating.bad' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div()
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.General.Layout' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_BoxGeneral.Root() ) ),
					[ 'col-xs-12', 'col-md-3' ]
				);

				// Zuschnitt Checkbox
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.General.Layout.Plot )
					{
						if ( this.m_Data.Data.General.Layout.Plot[ i ] ) { values.push( i ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'General.Layout.Plot',
								required: false,
								inline: 4,
								value: values,
								checkboxes:
								[
									{
										name: 'Towel',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.Layout.Plot.Towel' ),
										descriptor: {}
									},
									{
										name: 'Pipe',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.Layout.Plot.Pipe' ),
										descriptor: {}
									},
									{
										name: 'Corner',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.Layout.Plot.Corner' ),
										descriptor: {}
									},
									{
										name: 'Hillside',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.Layout.Plot.Hillside' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.appendTo( this.m_BoxGeneral.Root() ) ),
						[ 'col-xs-12', 'col-md-7' ]
					);
				}

				// Aussenanlage
				let fg = ui.$$.div().addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.General.OutdoorFacility.Garden' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_BoxGeneral.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'General.OutdoorFacility.Garden',
							value: [
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.inProgress',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.simple',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.average',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.expensive'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					 .value( this.m_Data.Data.General.OutdoorFacility.Garden ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				fg = ui.$$.div().addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.General.OutdoorFacility.Court' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_BoxGeneral.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'General.OutdoorFacility.Court',
							value: [
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.inProgress',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.simple',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.average',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.expensive'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					 .value( this.m_Data.Data.General.OutdoorFacility.Court ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				fg = ui.$$.div().addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.General.OutdoorFacility.Enclosure' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_BoxGeneral.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'General.OutdoorFacility.Enclosure',
							value: [
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.inProgress',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.simple',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.average',
								'Realtor.OBJECT.INPUT.PREMISE.General.OutdoorFacility.Rating.expensive'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					 .value( this.m_Data.Data.General.OutdoorFacility.Enclosure ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Zuweg
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'General.Entrance',
							required: false,
							inline: 3,
							value: this.m_Data.Data.General.Entrance || undefined,
							radioButtons:
							[
								{
									value: 'public',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.Entrance.public' ),
									descriptor: {}
								},
								{
									value: 'private',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.Entrance.private' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.General.Entrance' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_BoxGeneral.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Grundstücksfläche
				fg = ui.$$.div()
				.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.General.PlotArea' ) ).addClass( 'text-muted' ) )
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.PlotArea.Premise' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_BoxGeneral.Root() );
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.General.PlotArea.Premise || '',
						{
							name: 'General.PlotArea.Premise',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.PlotArea.Hinterland' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_BoxGeneral.Root() );
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.General.PlotArea.Hinterland || '',
						{
							name: 'General.PlotArea.Hinterland',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.General.PlotArea.Developed' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_BoxGeneral.Root() );
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.General.PlotArea.Developed || '',
						{
							name: 'General.PlotArea.Developed',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ]
				);

			}

			private showPremiseInfrastructure(): void
			{
				this.m_BoxInfrastructure.clearTitle();
				this.m_BoxInfrastructure.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.PREMISE.Infrastructure' ) );
				this.m_BoxInfrastructure.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Verkehrslage
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'Infrastructure.Traffic.Situation',
							required: false,
							inline: 4,
							value: this.m_Data.Data.Infrastructure.Traffic.Situation || undefined,
							radioButtons:
							[
								{
									value: 'MainRoad',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Traffic.Situation.main-road' ),
									descriptor: {}
								},
								{
									value: 'CommercialStreet',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Traffic.Situation.commercial-street' ),
									descriptor: {}
								},
								{
									value: 'ByRoad',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Traffic.Situation.byroad' ),
									descriptor: {}
								},
								{
									value: 'DeadEndRoad',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Traffic.Situation.dead-end-road' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.Infrastructure.Traffic.Situation' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_BoxInfrastructure.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Anbindungen
				let fg = ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.Infrastructure.Traffic.Connection' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_BoxInfrastructure.Root() );

				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'Infrastructure.Traffic.Connection.Rating',
							required: false,
							inline: 3,
							value: this.m_Data.Data.Infrastructure.Traffic.Connection.Rating || undefined,
							radioButtons:
							[
								{
									value: 'good',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Traffic.Connection.good' ),
									descriptor: {}
								},
								{
									value: 'middle',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Traffic.Connection.middle' ),
									descriptor: {}
								},
								{
									value: 'bad',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Traffic.Connection.bad' ),
									descriptor: {}
								}
							]
						}
					).rebuild( fg ),
					[ 'col-xs-9', 'col-md-7' ]
				);

				// KFZ erforderlich
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Infrastructure.Traffic.Connection.CarNeeded )
					{
						if ( this.m_Data.Data.Infrastructure.Traffic.Connection.CarNeeded[ i ] ) { values.push( i.toLowerCase() ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Infrastructure.Traffic.Connection.car-needed',
								required: false,
								value: values,
								checkboxes:
								[
									{
										name: 'carneeded',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Traffic.Connection.car-needed' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( fg ),
						[ 'col-xs-12', 'col-md-3' ]
					);
				}

				// Entfernung
				fg = ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.Infrastructure.Distance' ) ).addClass( 'text-muted' ) )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Distance.kindergarten' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_BoxInfrastructure.Root() );

				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Infrastructure.Distance.kindergarten',
							value: [
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step1',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step2',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step3'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					 .value( this.m_Data.Data.Infrastructure.Distance.Kindergarten ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Infrastructure.Distance.elementary-school',
							value: [
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step1',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step2',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step3'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Distance.elementary-school' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) )
					 .value( this.m_Data.Data.Infrastructure.Distance.ElementarySchool ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Infrastructure.Distance.second-school',
							value: [
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step1',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step2',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step3'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Distance.second-school' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) )
					.value( this.m_Data.Data.Infrastructure.Distance.SecondSchool ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Infrastructure.Distance.retail',
							value: [
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step1',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step2',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step3'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Distance.retail' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) )
					.value( this.m_Data.Data.Infrastructure.Distance.Retail ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Infrastructure.Distance.supermarket',
							value: [
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step1',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step2',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step3'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Distance.supermarket' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) )
					.value( this.m_Data.Data.Infrastructure.Distance.Supermarket ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Infrastructure.Distance.mall',
							value: [
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step1',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step2',
								'Realtor.OBJECT.LABEL.PREMISE.Distance.step3'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.Distance.mall' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) )
					.value( this.m_Data.Data.Infrastructure.Distance.Mall ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Öffentl Verkehrsmittel
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Infrastructure.PublicTransport )
					{
						if ( this.m_Data.Data.Infrastructure.PublicTransport[ i ] ) { values.push( i.toLowerCase() ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Infrastructure.PublicTransport',
								required: false,
								inline: 3,
								value: values,
								checkboxes:
								[
									{
										name: 'bus',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.PublicTransport.bus' ),
										descriptor: {}
									},
									{
										name: 'metro',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.PublicTransport.metro' ),
										descriptor: {}
									},
									{
										name: 'citytrain',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.PublicTransport.citytrain' ),
										descriptor: {}
									},
									{
										name: 'tram',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.PublicTransport.tram' ),
										descriptor: {}
									},
									{
										name: 'train',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.PublicTransport.train' ),
										descriptor: {}
									},
									{
										name: 'airport',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Infrastructure.PublicTransport.airport' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.Infrastructure.PublicTransport' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_BoxInfrastructure.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}
			}

			private showPremiseMicroMacro(): void
			{
				this.m_BoxMicroMacro.clearTitle();
				this.m_BoxMicroMacro.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.PREMISE.MicroMacro' ) );
				this.m_BoxMicroMacro.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Wohnlage
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'MicroMacro.ResidentialArea',
							required: false,
							inline: 3,
							value: this.m_Data.Data.MicroMacro.ResidentialArea || undefined,
							radioButtons:
							[
								{
									value: 'Downtown',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.ResidentialArea.Downtown' ),
									descriptor: {}
								},
								{
									value: 'CityRegion',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.ResidentialArea.CityRegion' ),
									descriptor: {}
								},
								{
									value: 'CommutingArea',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.ResidentialArea.CommutingArea' ),
									descriptor: {}
								},
								{
									value: 'rural',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.ResidentialArea.rural' ),
									descriptor: {}
								},
								{
									value: 'isolated',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.ResidentialArea.isolated' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.MicroMacro.ResidentialArea' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_BoxMicroMacro.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Wohngegend
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'MicroMacro.ResidentialDistrict',
							required: false,
							inline: 3,
							value: this.m_Data.Data.MicroMacro.ResidentialDistrict || undefined,
							radioButtons:
							[
								{
									value: 'ResidentialArea',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.ResidentialDistrict.ResidentialArea' ),
									descriptor: {}
								},
								{
									value: 'MixedUseArea',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.ResidentialDistrict.MixedUseArea' ),
									descriptor: {}
								},
								{
									value: 'IndustrialArea',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.ResidentialDistrict.IndustrialArea' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div().addClass( 'form-group' )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.MicroMacro.ResidentialDistrict' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_BoxMicroMacro.Root() ) ),
					[ 'col-xs-12', 'col-md-6' ]
				);

				// Ortslage
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'MicroMacro.Localitaion',
							required: false,
							inline: 4,
							value: this.m_Data.Data.MicroMacro.Localitaion || undefined,
							radioButtons:
							[
								{
									value: 'centre',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.Localitaion.centre' ),
									descriptor: {}
								},
								{
									value: 'outskirts',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.Localitaion.outskirts' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.MicroMacro.Localitaion' ) ).addClass( 'control-label col-xs-12 col-md-1' ) )
						.appendTo( this.m_BoxMicroMacro.Root() )
					),
					[ 'col-xs-12', 'col-md-3' ]
				);

				// Altersstruktur
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'MicroMacro.AgeStructure',
							required: false,
							inline: 3,
							value: this.m_Data.Data.MicroMacro.AgeStructure || undefined,
							radioButtons:
							[
								{
									value: 'OldBuilding',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.AgeStructure.OldBuilding' ),
									descriptor: {}
								},
								{
									value: 'NewBuilding',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.AgeStructure.NewBuilding' ),
									descriptor: {}
								},
								{
									value: 'MixedUseArea',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.MicroMacro.AgeStructure.MixedUseArea' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.MicroMacro.AgeStructure' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_BoxMicroMacro.Root() )
					),
					[ 'col-xs-12', 'col-md-10' ]
				);

			}

			private showPremiseGarages(): void
			{
				this.m_BoxGarages.clearTitle();
				this.m_BoxGarages.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.PREMISE.Garages' ) );
				this.m_BoxGarages.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Garagen
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				let fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.Garages.Garages' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_BoxGarages.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Garages.NumberGarages,
						{
							name: 'Garages.NumberGarages',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-1' ]
				);

				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'Garages.Place',
							required: false,
							inline: 4,
							value: this.m_Data.Data.Garages.Place,
							radioButtons:
							[
								{
									value: 'solid',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Garages.Place.solid' ),
									descriptor: {}
								},
								{
									value: 'withinHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Garages.Place.withinHouse' ),
									descriptor: {}
								},
								{
									value: 'besideHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Garages.Place.besideHouse' ),
									descriptor: {}
								},
								{
									value: 'detached',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Garages.Place.detached' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-9' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.Garages.Underground' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_BoxGarages.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Garages.Underground,
						{
							name: 'Garages.Undergroundgarage',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-1' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.PREMISE.Garages.Carport' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_BoxGarages.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Garages.Carport,
						{
							name: 'Garages.Carport',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-1' ]
				);

				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'Garages.KindOf',
							required: false,
							inline: 4,
							value: this.m_Data.Data.Garages.KindOf || undefined,
							radioButtons:
							[
								{
									value: 'open',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Garages.KindOf.open' ),
									descriptor: {}
								},
								{
									value: 'withRoof',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.PREMISE.Garages.KindOf.withroof' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
					.appendTo( this.m_BoxGarages.Root() ) ),
					[ 'col-xs-12', 'col-md-9' ]
				);

			}

		}

	}
}
